import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`
}));

export const GroupRow = styled('div')(({ theme }) => ({
  backgroundColor: theme.color.grey[400]
}));

export const RoleSection = styled('div')(() => ({
  width: '100%'
}));

export const RelationLink = styled(React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={className} {...props}>
    <span className="circle" />
    <span className="sphere" />
  </div>
)))(({ theme, main, last }) => ({
  float: 'left',
  height: '100%',
  left: '-7px',
  position: 'relative',
  top: '33px',
  width: 0,
  zIndex: 1,
  '&:after, &:before': {
    border: `0px dotted ${theme.color.primary.main}`,
    content: '""',
    display: 'block',
    left: '-7px',
    position: 'absolute',
    top: '7px'
  },
  '&:after': {
    borderTopWidth: '2px',
    width: '7px'
  },
  '&:before': {
    borderLeftWidth: '2px',
    height: '100%'
  },
  '.circle, .sphere': {
    borderRadius: '50%',
    boxSizing: 'border-box',
    position: 'absolute'
  },
  '.circle': {
    border: `1px solid ${theme.color.primary.main}`,
    height: '13px',
    left: '1px',
    top: '1px',
    width: '13px',
    zIndex: 1
  },
  '.sphere': {
    backgroundColor: theme.color.primary.main,
    height: '15px',
    width: '15px'
  },
  ...(main && {
    '.circle, .sphere': {
      backgroundColor: '#000000',
      borderColor: '#FFFFFF'
    },
    '&:after, &:before': {
      border: '0px solid #000000'
    },
    '&:after': {
      borderTopWidth: '1px'
    },
    '&:before': {
      borderLeftWidth: '1px'
    }
  }),
  ...(last && {
    '&:before': {
      height: '1px'
    }
  })
}));

RelationLink.propTypes = {
  last: PropTypes.bool,
  main: PropTypes.bool
};
